import {LocationInterface} from "@/shared/interfaces/LocationInterface";

export type GeoCoordinates = { lat: number, lng: number };

export class DistanceService {
    static calculateList(origin: GeoCoordinates, locationSet: Set<LocationInterface>) {
        const originRadLat = origin.lat * Math.PI / 180;
        const originRadLng = origin.lng * Math.PI / 180;
        const locations = Array.from(locationSet);

        locations.forEach((location: LocationInterface) => {
            if (!location.lat || !location.lng) return;
            const locationRadLat = parseFloat(location.lat) * Math.PI / 180;
            const locationRadLng = parseFloat(location.lng) * Math.PI / 180;
            const worldRadius = 6371; // km
            const x = (locationRadLng - originRadLng) * Math.cos((originRadLat + locationRadLat) / 2);
            const y = (locationRadLat - originRadLat);
            location.distance = Math.sqrt(x * x + y * y) * worldRadius;
        });

        return new Set(
            locations.sort((locationA: LocationInterface, locationB: LocationInterface) => {
                if (!locationA.distance || !locationB.distance) return 0;
                if (locationA.distance < locationB.distance) return -1;
                if (locationA.distance > locationB.distance) return 1;
                return 0;
            })
        );
    }

    static reset(locationSet: Set<LocationInterface>): Set<LocationInterface> {
        locationSet.forEach(item => delete item.distance);
        return locationSet;
    }
}
